import { render, staticRenderFns } from "./SafetypayCash.vue?vue&type=template&id=19bf555a"
import script from "./SafetypayCash.vue?vue&type=script&lang=js"
export * from "./SafetypayCash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports